<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half"><span class="bold">PHOENIX  13</span></p>
<p class="halfsub"><span class="bold">Americal Division Artillery Air</span></p>
<p class="halfsub1"><span class="bold">Section Helicopters in Vietnam</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?04d047b1